import type {RutaProd} from '../../../../runtime/rutas';
export default {
  "ruta": "/sistema/pos/tienda-en-linea/dashboard",
  "alias": [
    "/sistema/tienda-en-linea"
  ],
  "documento": "pos-store",
  "acceso": "sesion",
  "filas": [
    "110"
  ],
  "cita": "Areas/POS_Store/Controllers/DashboardController.cs"
} satisfies RutaProd;
